import { StrictEqualityComparer } from "../../shared/index.js";
import { BasicEnumerable } from "../BasicEnumerable.js";
export const intersect = (first, second, comparer = StrictEqualityComparer) => {
    function* iterator() {
        const firstResults = [...first.distinct(comparer)];
        if (firstResults.length === 0) {
            return;
        }
        const secondResults = [...second];
        for (let i = 0; i < firstResults.length; i++) {
            const firstValue = firstResults[i];
            for (let j = 0; j < secondResults.length; j++) {
                const secondValue = secondResults[j];
                if (comparer(firstValue, secondValue) === true) {
                    yield firstValue;
                    break;
                }
            }
        }
    }
    return new BasicEnumerable(iterator);
};
